__turbopack_context__.v({
  "Hamburger": "Hamburger-module-scss-module__UlT0aG__Hamburger",
  "IsActive": "Hamburger-module-scss-module__UlT0aG__IsActive",
  "Slice": "Hamburger-module-scss-module__UlT0aG__Slice",
});
